import styled from "styled-components";
import {
  getBorderRadius,
  getColor,
  getFadeInAnimation,
  getSize,
  responsive,
} from "~/helpers/style";
import { sidebarMobileHeight, sidebarWidth } from "./Sidebar.style";
import { UIProps } from "~/types/style";

interface IPageWrapper extends UIProps {
  padding: string;
}

interface IModal extends UIProps {
  minWidth: string | number;
}

export const PageWrapper = styled.div<IPageWrapper>`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - ${sidebarMobileHeight}px);
  max-height: calc(100vh - ${sidebarMobileHeight}px);
  overflow-y: auto;
  width: 100vw;
  left: 0;
  top: ${sidebarMobileHeight}px;
  position: fixed;
  padding: ${getSize(1.25)};
  background-color: ${getColor("background")};
  ${getFadeInAnimation(0.5)}

  ${responsive("tablet")} {
    min-height: 100vh;
    max-height: 100vh;
    padding: ${({ padding }) => padding};
    width: calc(100vw - ${sidebarWidth}px);
    top: 0;
    left: ${sidebarWidth}px;
  }
`;

export const PageWrapperFullscreen = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
  width: 100vw;
  background-color: ${getColor("background")};
  ${getFadeInAnimation(0.5)}
`;

export const PageMaxWidth = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
`;

export const PageHeader = styled.div`
  display: flex;
  direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-left: auto;
`;

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2;
  // Fade in the modal once added to the DOM
  ${getFadeInAnimation(0.3)}
`;

export const ModalContent = styled.div<IModal>`
  position: fixed;
  background: white;
  min-width: ${({ minWidth }) => minWidth};
  height: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: ${getBorderRadius(1.2)};
  max-height: 80%;
  overflow: auto;
  padding: ${getSize(3.2)};
  ${responsive("tablet")} {
    padding: ${getSize(5.8)};
  }
`;
